const BASE_CLASS = 'input__stripe';

const STRIPE_INPUT_STYLES = {
  base: {
    color: '#0f141a',
    fontSize: '14px',
    '::placeholder': {
      color: '#9da2a6',
    },
  },
  invalid: {
    color: '#0f141a',
  },
};

const StripeInputAdapter = Component => ({
  label,
  error,
  invalid,
  ...rest
}) => (
  <div className={cx({ input_error: error || invalid })}>
    <label>
      <div className="input__label _mb-7">{label}</div>
      <Component
        classes={{
          base: `input ${BASE_CLASS}`,
          empty: `${BASE_CLASS}-empty`,
          complete: `${BASE_CLASS}-complete`,
          invalid: `${BASE_CLASS}-invalid`,
          focus: `${BASE_CLASS}-focus`,
        }}
        style={STRIPE_INPUT_STYLES}
        {...rest}
      />
    </label>
    {error && <div className="input-error-text">{error}</div>}
  </div>
);

export default StripeInputAdapter;
